import { render, staticRenderFns } from "./LeadershipOffice.vue?vue&type=template&id=33d41d8f&lang=pug"
import script from "./LeadershipOffice.vue?vue&type=script&lang=js"
export * from "./LeadershipOffice.vue?vue&type=script&lang=js"
import style0 from "./LeadershipOffice.vue?vue&type=style&index=0&id=33d41d8f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports